/**
 * Pure helpers for letter bodies. The server is the authority on merging; these
 * only inspect and build the HTML the editor round-trips. No '@/utils' barrel
 * import on purpose — this module is unit-tested.
 */

export const TOKEN_RE = /\{\{\s*([a-zA-Z][a-zA-Z0-9_]*(?:\.[a-zA-Z0-9_]+)*)\s*\}\}/g;
export const CHIP_RE = /<span\b[^>]*\bdata-merge="([^"]+)"[^>]*>[\s\S]*?<\/span>/gi;
export const FILL_RE = /<span\b[^>]*\bdata-fill="([^"]*)"[^>]*>[\s\S]*?<\/span>/gi;

export const decodeEntities = (value = '') =>
  String(value)
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0?39;/g, "'");

export const escapeAttr = (value = '') =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

/** Unique {{tokens}} in a body, bare or wrapped in an editor chip. */
export function tokensIn(html = '') {
  const found = [];
  for (const match of String(html).matchAll(CHIP_RE)) found.push(decodeEntities(match[1]));
  for (const match of String(html).matchAll(TOKEN_RE)) found.push(match[1]);
  return [...new Set(found)];
}

/** Labels of the fill-in prompts still in a body. */
export function fillInsIn(html = '') {
  return [...String(html).matchAll(FILL_RE)].map((match) => decodeEntities(match[1]).trim());
}

export function mergeChipHtml(token, label = null) {
  const text = label || token;
  return `<span data-merge="${escapeAttr(token)}" data-label="${escapeAttr(text)}">${escapeAttr(text)}</span>`;
}

export function fillInHtml(label) {
  return `<span data-fill="${escapeAttr(label)}">[${escapeAttr(label)}]</span>`;
}

/** Flat list of { token, label, group } from the catalog groups. */
export function flattenGroups(groups = []) {
  const out = [];
  for (const group of groups) {
    for (const field of group.fields || []) {
      out.push({ token: field.token, label: field.label, type: field.type, group: group.label });
    }
  }
  return out;
}

export function labelFor(token, groups = []) {
  const hit = flattenGroups(groups).find((f) => f.token === token);
  return hit ? hit.label : token;
}
